// extracted by mini-css-extract-plugin
var _1 = "ActivityTab__outer--XSJcq general__shadow--ifbUf";
var _2 = "ActivityTab__scrollBar--FMv2p general__scrollBar--nOeLI";
var _3 = "ActivityTab__scrollContent--cQmTE";
var _4 = "ActivityTab__scrollThumb--u5Gta general__scrollThumb--k3VcQ";
export { _1 as "outer", _2 as "scrollBar", _3 as "scrollContent", _4 as "scrollThumb" }
